/* Pinzelli : empêche la page produit de « sauter » toute seule vers le bas (avis) sur mobile.
   1. Pas de restauration automatique de la position de défilement au rechargement (navigateur Instagram / Safari),
      sauf si l'adresse contient une ancre (#avis, etc.).
   2. Les popups (Klaviyo…) qui donnent le focus à un bouton ne font plus défiler la page. */
(function () {
  try { if ('scrollRestoration' in history && !location.hash) history.scrollRestoration = 'manual'; } catch (e) {}
  try {
    var fo = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (opts) {
      try {
        if (this.closest && this.closest('[class*="klaviyo"], .needsclick, [class*="kl-"]')) {
          var o = {}; if (opts && typeof opts === 'object') for (var k in opts) o[k] = opts[k];
          o.preventScroll = true;
          return fo.call(this, o);
        }
      } catch (e) {}
      return fo.apply(this, arguments);
    };
  } catch (e) {}
})();